import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: "n-modal-footer",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
      <div class="n-modal-footer" [class.sticky]="sticky$|async" [stickyBodyInject]="true"
           [nStickyBlock]="'bottom'" (stickChanged)="sticky$.next($event)" [stickyDisabled]="!sticky">
          <ng-content></ng-content>
      </div>`,
  styleUrls: [
    "./n-modal-footer.css",
  ],
})
export class NModalFooterComponent {
  @Input() sticky: boolean;

  sticky$ = new BehaviorSubject<boolean>(false);
}
